import {event} from '../modules/event';
import {cookie} from '../modules/cookie';

var notificationPopup = function(wrapper){

    var cancelBtn = wrapper.querySelector('[data-notificationPopup-cancel]'),
        showBtn = wrapper.querySelector('[data-notificationPopup-show]'),
        popup,
        show = function(){
            if(APP.vars.isMobile){
                popup = uPopup({
                    addClass: 'popup-notification',
                    content: wrapper
                });
            } else{
                wrapper.className = wrapper.className + ' js-active';
            }
        },
        hide = function(){
            if(APP.vars.isMobile){
                uPopup.closeAll();
            } else{
                wrapper.className = wrapper.className.replace(' js-active', '');
            }
        },
        setCookie = function(expires){
            var options = {};

            options.expires = expires;
            options.path = '/';
            options.domain = '.kinoafisha.info'; //.kinoafishaspb.ru

            cookie.setCookie('ka_push_showed', 'ok', options);
        },
        add = function(){
            cancelBtn.onclick = function(e){
                if(e) e.preventDefault();
                setCookie(3600*24*30);
                hide();
                return false;
            };
            showBtn.onclick = function(){
                setCookie(3600*24);
                hide();
            }
            show();
        };

    //
    if (!('serviceWorker' in navigator)) return false; /* не работает с http */
    if (!navigator.cookieEnabled) return false;

    if (document.readyState === "complete") {
        add();
    }
    else {
        event.add(window, 'load', add);
    }
}

export {notificationPopup};










